export default __webpack_public_path__ + "static/media/DocDB.78fe5bac.svg";